// Bus de eventos global para cambios en expedientes, trámites y clientes
// (crear, editar, eliminar). Mismo patrón que tareasBus.js, generalizado:
// cualquier vista que muestre listas o referencias a estas entidades puede
// suscribirse para mantenerse sincronizada sin que cada componente padre
// tenga que pasar manualmente un callback "onUpdate" a cada hijo.
const target = new EventTarget();
const EVENT = 'entidad-changed';

// detail: { tipo: 'expediente' | 'tramite' | 'cliente', id, eliminado? }
export function emitEntidadChanged(detail) {
  target.dispatchEvent(new CustomEvent(EVENT, { detail }));
}

// handler recibe el detail. Devuelve función para desuscribirse.
// Si se pasa `tipo`, el handler solo se llama para eventos de ese tipo.
export function onEntidadChanged(handler, tipo = null) {
  const listener = (e) => {
    if (tipo && e.detail?.tipo !== tipo) return;
    handler(e.detail);
  };
  target.addEventListener(EVENT, listener);
  return () => target.removeEventListener(EVENT, listener);
}
